import React from 'react'
import { DatePicker } from '@material-ui/pickers'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

// import SetWeekDialog from 'components/SetWeekDialog'

class ForecastsDateFilterModal extends React.Component {
  state = {
    weekDialogOpen: false,
  }

  openWeekDialog = () => {
    this.setState({ weekDialogOpen: true })
  }

  closeWeekDialog = () => {
    this.setState({ weekDialogOpen: false })
  }

  onSetWeek = weekNumber => {
    this.closeWeekDialog()
    this.props.onSetWeek(weekNumber)
  }

  render() {
    const props = this.props

    return (
      <React.Fragment>
        {props.open && (
          <Dialog open={!this.state.weekDialogOpen} onClose={props.onClose}>
            <DialogTitle id="confirmation-dialog-title">Periodo</DialogTitle>
            <DialogContent>
              <MenuList style={{ marginTop: -10, marginBottom: 10 }}>
                <MenuItem onClick={() => props.onSetPeriod('today')}>Hoy</MenuItem>
                <MenuItem onClick={() => props.onSetPeriod('tomorrow')}>Mañana</MenuItem>
              </MenuList>
            </DialogContent>
            <DialogActions>
              {props.onClear && <Button onClick={props.onClear}>Borrar</Button>}
              <Button onClick={props.onClose} color="primary">
                Filtrar
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </React.Fragment>
    )
  }
}

const styles = {
  datePicker: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial' !important",
  },
}

export default withStyles(styles)(ForecastsDateFilterModal)



// WEBPACK FOOTER //
// ./src/components/ForecastsDateFilterModal.js